<!-- Deskto HTML -->
<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-manage-subscription">
      <div class="bmw-sm-manage-subscription-title">
        Manage Subscriptions
      </div>
      <div class="row bmw-no-gutter bmw-sm-manage-subscription-list">
        <div *ngFor='let channel of videosSubscriptionList'>
          <div class="bmw-sm-manage-subscription-channel">
            <div class="bmw-sm-manage-subscription-channel-number">
              {{channel.channelNumber}}
            </div>
            <div class="bmw-sm-manage-subscription-channel-name">
              {{channel.channelName.length > 23 ? channel.channelName.substr(0,20)+'...' : channel.channelName}}
            </div>
            <div class="row bmw-no-gutter pointer" (click)='toggleChannelSubsciprtion(channel.channelNumber)'>
              <div *ngIf="isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock"></div>
              <ng-template #thenBlock>
                <div class="bmw-sm-videos-subscribe-btn checked" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22":APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>
                  <div class="col-lg-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">check_circle</i></div>
                  <div class="col-lg-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribed
                  </div>
                </div>
              </ng-template>
              <ng-template #elseBlock>
                <div class="bmw-sm-videos-subscribe-btn unchecked">
                  <div class="col-lg-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">add_circle_outline</i></div>
                  <div class="col-lg-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribe
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="row pointer bmw-no-gutter bmw-lg-video-channel-buttons">
        <div class="bmw-video-channel-btn bmw-button-secondary pointer">
          <label style="margin-top: 5px">Cancel</label>
        </div>
        <div class="pointer bmw-video-channel-btn bmw-button-primary done" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22":APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}' (click)='applySubscriptionChanges()'>
          <label style="margin-top: 5px">Done</label>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-md-manage-subscription">
      <div class="bmw-sm-manage-subscription-title">
        Manage Subscriptions
      </div>
      <div class="row bmw-no-gutter bmw-sm-manage-subscription-list">
        <div *ngFor='let channel of videosSubscriptionList'>
          <div class="bmw-sm-manage-subscription-channel">
            <div class="bmw-sm-manage-subscription-channel-number">
              {{channel.channelNumber}}
            </div>
            <div class="bmw-sm-manage-subscription-channel-name">
              {{channel.channelName.length > 23 ? channel.channelName.substr(0,20)+'...' : channel.channelName}}
            </div>
            <div class="row bmw-no-gutter pointer" (click)='toggleChannelSubsciprtion(channel.channelNumber)'>
              <div *ngIf="isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock"></div>
              <ng-template #thenBlock>
                <div class="bmw-sm-videos-subscribe-btn checked" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22":APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>
                  <div class="col-md-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">check_circle</i></div>
                  <div class="col-md-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribed
                  </div>
                </div>
              </ng-template>
              <ng-template #elseBlock>
                <div class="bmw-sm-videos-subscribe-btn unchecked">
                  <div class="col-md-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">add_circle_outline</i></div>
                  <div class="col-md-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribe
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-video-channel-btn" (click)='applySubscriptionChanges()'>Apply</div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-sm-manage-subscription">
      <div class="bmw-sm-manage-subscription-title">
        Manage Subscriptions
      </div>
      <div class="row bmw-no-gutter bmw-sm-manage-subscription-list">
        <div *ngFor='let channel of videosSubscriptionList'>
          <div class="bmw-sm-manage-subscription-channel">
            <div class="bmw-sm-manage-subscription-channel-number">
              {{channel.channelNumber}}
            </div>
            <div class="bmw-sm-manage-subscription-channel-name">
              {{channel.channelName.length > 23 ? channel.channelName.substr(0,20)+'...' : channel.channelName}}
            </div>
            <div class="row bmw-no-gutter pointer" (click)='toggleChannelSubsciprtion(channel.channelNumber)'>
              <div *ngIf="isChannelSubscribed(channel.channelNumber); then thenBlock else elseBlock"></div>
              <ng-template #thenBlock>
                <div class="bmw-sm-videos-subscribe-btn checked" [ngStyle]='{"background-color": APP_SETTINGS.isMINI === "true" ? "#bf1a22":APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>
                  <div class="col-sm-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">check_circle</i></div>
                  <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribed
                  </div>
                </div>
              </ng-template>
              <ng-template #elseBlock>
                <div class="bmw-sm-videos-subscribe-btn unchecked">
                  <div class="col-sm-2 bmw-no-gutter"><i class="material-icons" style="font-size: 20px">add_circle_outline</i></div>
                  <div class="col-sm-10 bmw-no-gutter" style="font-size: 14px; padding-left: 6px">
                    Subscribe
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-video-channel-btn" (click)='applySubscriptionChanges()'>Apply</div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-xs-manage-subscription">
      <div class="row bmw-no-gutter bmw-xs-row-manage-subscription-header" [ngStyle]='{"color": APP_SETTINGS.isMINI === "true" ? "#bf1a22":APP_SETTINGS.isRollsRoyce === "true"? "#281432" : "#1c69d4"}'>
        <div class="col-xs-4 bmw-no-gutter" style="padding-left: 5px"><a routerLink='../subscription'>Back</a></div>
        <div class="col-xs-8 bmw-no-gutter" style="text-align: right">
          <a routerLink='../channels'>
          <span>Add Channels </span>
          <i class="material-icons" style="vertical-align: middle">arrow_forward</i>
        </a>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-xs-manage-subscription-list">
        <div *ngFor='let channel of videosSubscriptionList'>
          <div class="row bmw-no-gutter" style="margin-top:10px">
            <div class="col-xs-2 bmw-no-gutter circle">
              {{channel.channelNumber}}
            </div>
            <div class="col-xs-9 bmw-no-gutter" style="padding-left:10px;padding-top: 2%;">
              <span>{{channel.channelName}}</span>
            </div>
            <div class="col-xs-1 bmw-no-gutter" style="text-align: right">
              <div class="dropdown dropdown-pull-right btn-group">
                <i class="material-icons bmw-xs-manage-suscription-more" data-toggle="dropdown">more_vert</i>
                <ul class="dropdown-menu" style="width: 210px">
                  <li class="row bmw-no-gutter">
                    <div style="padding-left: 5px; float: left">
                      <i class="material-icons dp48" style="font-size:20px">delete_forever</i>
                    </div>
                    <div style="margin-left: 5px; float: left" (click)='toggleChannelSubsciprtion(channel.channelNumber)'>
                      Remove from subscriptions
                    </div>
                  </li>
                  <li class="divider"></li>
                  <li class="row bmw-no-gutter">
                    <div style="padding-left: 5px; float: left">
                      <i class="material-icons" style="font-size:20px">close</i>
                    </div>
                    <div style="margin-left: 5px; float: left">
                      Cancel
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row bmw-no-gutter bmw-video-channel-btn" (click)='applySubscriptionChanges()'>Apply</div>
    </div>
  </div>
</div>
